import Tutorial from './Tutorial';
import common from '../../common';
import WalkCommand from '../../commands/WalkCommand';
import {translate} from '../../utils';

export default class TutorialLevel1 extends Tutorial {
	constructor(finger, panel, scene, commands) {
		super(finger, panel, scene, commands);
	}

	update() {
		super.update();
	}

	play() {
		super.play();

		if (this._destroyed) {
			return;
		}

		this.tweens.removeAll();

		let lastTween = null;

		this._commands.ui.disposal.visible = false;
		this._scene.cameraButton.interactive = false;

		if (this.stage === 0) {
			common.focusOverlay.setFocus(0, (common.STAGE_HEIGHT * 0.5) - 75, P3.View.width, 150);
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 400 - this._commands.ui.x, (common.STAGE_HEIGHT * 0.5));
			this._commands.ui.interactive = false;
			this._commands.ui.interactiveChildren = false;
			this._commands.ui.add.interactive = false;
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE1.SWIPE');

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 1000)
				.easing(P3.utils.Easing.Back2.Out)
				.start();

			new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 1000)
				.easing(P3.utils.Easing.Back2.Out)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					x: (common.STAGE_WIDTH * 0.5) - 400 - this._commands.ui.x
				}, 1250)
				.easing(P3.utils.TWEEN.Easing.Linear.None);

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 1) {
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 80, 125);
			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			this._commands.ui.add.interactive = true;
			common.focusOverlay.focusSprite(this._commands.ui.add, true);
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE1.TAP');

			new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();
		} else if (this.stage === 2) {
			const focusWidth = common.STAGE_WIDTH * 0.5 - (common.STAGE_WIDTH - P3.View.width) * 0.5 + 100;

			common.focusOverlay.setFocus(20, 10, focusWidth, 300);
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 80, 180);
			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			this._commands.ui.add.interactive = false;
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE1.DRAG');

			const t1 = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					x : (common.STAGE_WIDTH - P3.View.width) * 0.5 + 200,
					y : [300, 350]
				}, 750)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.interpolation(P3.utils.TWEEN.Interpolation.Bezier)
				.delay(500)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					alpha: 0
				}, 500)
				.easing(P3.utils.TWEEN.Easing.Linear.None);

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 3) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 100 - this._commands.ui.x, common.STAGE_HEIGHT - 180);
			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			common.focusOverlay.focusSprite(this._scene.runButton);
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE1.RUN');

			new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();
		}

		if (lastTween) {
			lastTween.onComplete(() => {
				P3.utils.delayg(this.tweens, 0.5, () => {
					this.play();
				});
			});
		}
	}

	stop() {
		super.stop();
	}

	prepareCommands() {
		super.prepareCommands();

		for (let i = 0; i < 2; i++) {
			const command = new WalkCommand();

			command.template = false;
			command.grabbable = false;
			command.locked = true;
			command.placed = true;
			command.x = 169;
			command.setText(command.defaultVariable);
			this._commands.commandContainer.addChild(command);

			for (const comm of this._commands.commands) {
				comm.slotPosition.set(comm.position.x, comm.position.y);
			}

			this._commands.commands.splice(i + 1, 0, command);
			this._commands.resize();
		}
	}
}
